module.exports = __webpack_public_path__ + "static/media/pledgeWhite.8ba858c2.svg";